<template>
  <component
    :is="varComp"
    :hover="hovering"
    variant=""
    :resource="resource"
    :webpage="webpage"
  ></component>
</template>

<script>
import WebpageFull from './WebpageFull';
import WebpageFooter from './WebpageFooter';
import WebpageListItem from './WebpageListItem';

export default {
  components: { WebpageFull, WebpageListItem, WebpageFooter },
  props: {
    hovering: {},
    blockData: {
      default: () => ({
        resource: {},
        excerpts: []
      })
    },
    blockType: {},
    variant: {}
  },
  data() {
    return {
      comps: {
        full: WebpageFull,
        footer: WebpageFooter,
        listItem: WebpageListItem
      }
    }
  },
  computed: {
    varComp() {
      return this.comps[this.variant];
    },
    resource() {
      return this.blockData.resource;
    },
    webpage() {
      return this.blockData.resource ? this.blockData.resource.resourceData : {};
    }
  }
};
</script>
